import { useRequest } from './../providers/useRequest';
import IUser from '../../interfaces/IUser';
import AppError from '../../errors/AppError';
import ILogin from '../../interfaces/ILogin';

const useLoginService = () => {
  const request = useRequest<IUser>();
  const path = 'auth';
  const login = async (user: ILogin): Promise<IUser> => {
    return await request
      .post({ path: `${path}/login`, body: user, sendAuthorization: false })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  return { login };
};

export { useLoginService };
